import React from 'react';
import ArsLoader from 'src/common/components/ArsLoader';
import { TheContent, TheSidebar, TheFooter, TheHeader } from './index';
import Websocket from 'src/common/components/Websocket';

const TheLayout = () => {
  return (
    <div className="c-app c-default-layout">
      <Websocket>
        <TheSidebar />
        <div className="c-wrapper">
          <TheHeader />
          <div className="c-body">
            <TheContent />
          </div>
          <TheFooter />
        </div>
        <ArsLoader />
      </Websocket>
    </div>
  );
};

export default TheLayout;
